module.exports = __webpack_public_path__ + "img/tong.7ca2f931.png";